const db = ['mysql', 'postgresql', 'tidb'];

const isDB = (integration: string) => {
  const lowerCaseIntegration = integration.toLowerCase();
  return db.includes(lowerCaseIntegration);
};

export default isDB;
